import { QueryClient } from '@tanstack/react-query';

/**
 * The single CORTEX TanStack Query client.
 *
 * Defaults chosen for an internal underwriting tool where staff keep the
 * app open for hours:
 *  - `staleTime` 30s: avoid refetch storms on every focus change while
 *    keeping data reasonably fresh.
 *  - `refetchOnWindowFocus` off: an underwriter tabbing back from email
 *    should not trigger a wall of network calls. Mutations and explicit
 *    invalidation drive freshness instead.
 *  - `retry` 1: one retry smooths a transient blip; more would mask real
 *    errors and delay the error state the UI must show.
 *
 * Server state (anything from the API) belongs in Query. Local UI state
 * (form drafts, which row is selected) stays in component state.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});
